if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
       // alert("fff");
    }

    showActiveMedia() {
      // this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
      //     element.classList.remove('is-active');
      //   }
      // )
      // const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      // const activeMediaTemplate = activeMedia.querySelector('template');
      // const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      // activeMedia.classList.add('is-active');
      // activeMedia.scrollIntoView();

      // const container = this.querySelector('[role="document"]');
      // container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      // if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
      //   activeMedia.loadContent();
      
//       var clickedElement = event.target;
//      var mediaId = clickedElement.getAttribute('data-index');
//     console.log('Clicked element ID:', mediaId);
//       var swiperr = new Swiper('.swiper');
//       swiperr.destroy();
//       setTimeout(function() {
//         const swiperr = new Swiper('.swiper', {
//       direction: 'horizontal',
//       loop: true,
//       slidesPerView: 1,
//       spaceBetween: 0,
//       centeredSlides: true,
//       allowTouchMove: false,
//       pagination: {
//         el: '.swiper-pagination',
//         type: 'fraction', // Display fraction (e.g., "1/3")
//         clickable: true,
//       },
//       navigation: {
//         nextEl: '.swiper-button-next',
//         prevEl: '.swiper-button-prev',
//       },
//       breakpoints: {
//         // Disable centeredSlides on smaller screens
//         768: {
//           centeredSlides: false,
//           allowTouchMove: false,
//         },
//       },
//     });
//     swiperr.slideTo(mediaId);
//   console.log('Active slide:', swiperr.activeIndex);
// }, 500); 
      var clickedElement = event.target;
var mediaId = clickedElement.getAttribute('data-media-id');
console.log('Clicked element ID:', mediaId);

var swiperr = new Swiper('.swiper');
swiperr.destroy();  
var swiperr = new Swiper('.swiper', {
      direction: 'horizontal',
      loop: true,
      speed: 500,
      effect: 'fade',
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      allowTouchMove: false,
      pagination: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        // Disable centeredSlides on smaller screens
        768: {
          centeredSlides: false,
          allowTouchMove: false,
        },
      },
    });
var slides = document.querySelectorAll('.swiper-slide');


var targetSlideIndex = -1;
var slidesIndex = 0;
for (var i = 1; i <= slides.length; i++) {
    var slideMediaId = slides[i].getAttribute('data-media-id');
   console.log(slideMediaId + "/" + mediaId + "/" + i );
    if (slideMediaId == mediaId) {
      console.log('Matched slide:', slideMediaId);
        targetSlideIndex = slidesIndex;
        break;
    }
   slidesIndex++;
}
console.log('Target slide:', targetSlideIndex);
// Go to the slide if a match is found
if (targetSlideIndex != -1) {
    setTimeout(function () {
        swiperr.slideTo(targetSlideIndex);
        console.log('Active slide:', swiperr.activeIndex);
    }, 200);
} else {
    console.log('No matching slide found for mediaId:', mediaId);
}

    }
  });
}
